/**
 * Admin theme imperative API (MFE-v3-S-3) — DECISION-2 C-Hybrid.
 *
 * - `applyInitialTheme()` runs in `main.tsx` before React renders.
 * - Persists under `rpapp-admin-theme` in this browser's `localStorage`.
 * - Default is **light**; dark only after the user toggles (not OS `prefers-color-scheme`).
 * - Dark mode uses `.dark` on `<html>`; explicit light uses `.light`.
 *
 * React bridge: `ThemeProvider.tsx`.
 * SSOT: `pi-kiosk-shared/theme` (`themeContract.ts`).
 */

import {
  createThemeApi,
  THEME_STORAGE_KEYS,
  type EffectiveTheme,
  type ThemePreference,
} from 'pi-kiosk-shared/theme';

export type { EffectiveTheme, ThemePreference };

const adminThemeOptions = {
  lightOverrideEnabled: true,
  defaultPreference: 'light' as const,
  systemResolvesTo: 'light' as const,
};

const adminThemeApi = createThemeApi(THEME_STORAGE_KEYS.admin, adminThemeOptions);

export const applyInitialTheme = adminThemeApi.applyInitialTheme;

export const setTheme = adminThemeApi.setTheme;

export const getThemePreference = adminThemeApi.getThemePreference;

export const getEffectiveTheme = adminThemeApi.getEffectiveTheme;

export const subscribeToSystemTheme = adminThemeApi.subscribeToSystemTheme;

export const ADMIN_THEME_STORAGE_KEY = THEME_STORAGE_KEYS.admin;

export { adminThemeOptions };
